export const SET_DEALERS= 'SET_DEALERS'
export const SELECT_PRODUCTS = 'SELECT_PRODUCTS'
export const ADD_DEALER = 'ADD_DEALER'
export const REMOVE_DEALER = 'REMOVE_DEALER'
export const UPDATE_DEALER = 'UPDATE_DEALER'
export const SET_PRODUCT_BY_ID = 'SET_PRODUCT_BY_ID'